import {gettext} from '../utils/text';

// eslint-disable-next-line import/prefer-default-export
export const WORKERS = {
    ROLES: {
        UNSPECIFIED: {value: 'unspecified', label: gettext('Unspecified')},
        WELDER: {value: 'welder', label: gettext('Welder')},
        FINISHER: {value: 'finisher', label: gettext('Finisher')},
        BUNDLER: {value: 'bundler', label: gettext('Bundler')},
        QUALITY: {value: 'quality', label: gettext('Quality assurance')},
        PRODUCTION: {value: 'production', label: gettext('Production manager')},
    },
};



// WEBPACK FOOTER //
// ./src/constants/accounts.js